module.exports = __webpack_public_path__ + "static/media/fast.dd1414dc.png";